/* @flow */
/** @jsx h */
import { h, Component } from 'preact';
import styles from './index.css';
import { ArrowButton } from '../../../formats/video-sdk3/components/arrow-button/arrow-button';

type CTAOverlayProp = {
  onClick: (e: MouseEvent) => void;
};

export class CTAOverlay extends Component<CTAOverlayProp> {
  render() {
    const { onClick = () => {} } = this.props;

    return (
      <div className={styles.ctaOverlay} onClick={onClick}>
        <ArrowButton size={40} color="#015a95" />
      </div>
    );
  }
}
